import { useMutation, useQueryClient } from "@tanstack/react-query";
import { saveHarvestConfig, type HarvestConfigDto } from "../api/harvestApi";

export function useSaveHarvestConfig() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (dto: HarvestConfigDto) => saveHarvestConfig(dto),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["harvest", "config"] }),
  });
}
